module.exports = __webpack_public_path__ + "static/media/logo.8af03dc1.png";